module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"more":"For more information click","here":"here"}}')
  delete Component.options._Ctor
}
